import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Container, Box, CircularProgress, Typography } from "@mui/material";
import { useTheme } from "styled-components";
import { fetchChallengeSubmissions } from "../../services/submissionService";
import ViewAllSubmissionsSection from "../organisms/ViewAllSubmissionsSection";

const ViewAllSubmissionsPage = () => {
  const { challengeId } = useParams();
  const theme = useTheme();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [headerText, setHeaderText] = useState("All Submissions");
  const [submissions, setSubmissions] = useState([]);

  useEffect(() => {
    const fetchSubmissions = async () => {
      setLoading(true);
      setError(null); // Reset error state before fetching
      try {
        let fetchedSubmissions;

        if (challengeId) {
          // Fetch submissions for the specific challengeId
          fetchedSubmissions = await fetchChallengeSubmissions(challengeId);
          setHeaderText(`Submissions for "${fetchedSubmissions[0]?.challengeData.title}" Challenge`);
        } else {
          // Fetch all submissions
          fetchedSubmissions = await fetchChallengeSubmissions();
          setHeaderText("Latest Submissions");
        }

        setSubmissions(fetchedSubmissions);
      } catch (err) {
        setError("Error fetching submissions data.");
      } finally {
        setLoading(false);
      }
    };

    fetchSubmissions();
  }, [challengeId]);

  if (loading) {
    return (
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "60vh",
          }}
        >
          <CircularProgress
            sx={{
              color: theme.colors.red,
            }}
          />
        </Box>
      </Container>
    );
  }

  if (error) {
    return (
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "60vh", // Optional: To maintain consistent height with loading state
          }}
        >
          <Typography variant="h6" color="error">
            {error}
          </Typography>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="xl" sx={{ mt: 4 }}>
      <Box>
        <ViewAllSubmissionsSection
          header={headerText}
          submissions={submissions}
          theme={theme}
        />
      </Box>
    </Container>
  );
};

export default ViewAllSubmissionsPage;
